import moment from "moment";
import { dateFormat } from "../common/GeneralConfigurations";

export const OfferedAtValidation = [
    { required: true, message: "Offered At is required" },
];

export const NumberValidation = (form) => [
    { required: true, message: "Number is required" },
    { pattern: /^(F|I)?[0-9]*$/g, message: "Number is invalid" },
    {
        validator: async (_, number) => {
            if (number) {
                let contractTypeId = form.getFieldValue("contractTypeId");
                if (contractTypeId != null) {
                    if (
                        (contractTypeId == 2 && !/^(F|I)?[0-9]*$/g.test(number)) ||
                        (contractTypeId != 2 && !/^[0-9]*$/g.test(number))
                    ) {
                        return Promise.reject("Number is invalid");
                    }
                }
            }
        },
    },
];

export const AdmissionCtiValidation = (form, required) => {
    let validations = [
        {
            validator: async (_, admissionCtiDate) => {
                if (admissionCtiDate) {
                    let admissionDate = form.getFieldValue("admissionDate");
                    if (admissionDate != null)
                        if (admissionCtiDate < admissionDate) {
                            return Promise.reject(
                                "Must be greater than Admission Date."
                            );
                        }
                }
            },
        },
    ];
    if (required) {
        validations.push({ required: true, message: "Admission CTI Date is required" },);
    }
    return validations;
};

export const WelcomeMeetingValidation = (form) => [
    {
        validator: async (_, welcomeMeetingDate) => {
            if (welcomeMeetingDate) {
                let admissionDate = form.getFieldValue("admissionDate");
                if (admissionDate != null)
                    if (welcomeMeetingDate <= admissionDate) {
                        return Promise.reject(
                            "Must be equal or greater than Admission Date."
                        );
                    }
            }
        },
    },
];

export const ResignationDateValidation = (form) => [
    {
        validator: async (_, resignationDate) => {
            if (resignationDate) {
                let admissionDate = form.getFieldValue("admissionDate");
                if (admissionDate != null && resignationDate != null)
                    if (resignationDate <= admissionDate) {
                        return Promise.reject("Must be greater than Admission Date.");
                    }
            }
        },
    },
];

export const AdmissionDateValidation = (form) => [
    {
        validator: async (_, admissionDate) => {
            let birthDate = form.getFieldValue("birthDate");
            if (birthDate != null)
                if (admissionDate <= birthDate) {
                    return Promise.reject("Must be greater than Birth Date.");
                }
        },
    },
    { required: true, message: "Admission Date is required" },
];

export const BirthDateValidation = [
    { required: true, message: "Birth Date is required" },
];
